import { render, staticRenderFns } from "./FuncionarioImport.vue?vue&type=template&id=7f852139"
import script from "./FuncionarioImport.vue?vue&type=script&lang=js"
export * from "./FuncionarioImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports